import React from 'react';

export default function renderSponsorsCheckbox (sponsor, sponsors) {
  if (sponsors && sponsors.length) {
    return sponsors.map(sponsor => (
      <div key={`previous_webinars_sponsor_${sponsor.id}`}>
        <div className="sponsor_name_check">{sponsor && sponsor.title && <p>{sponsor.title}</p>}</div>
      </div>
    ))
  } else {
    return (
      <div>
        <div className="sponsor_name_check">{sponsor && sponsor.title && <p>{sponsor.title}</p>}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/renderSponsorCheckbox.js